// removed by extract-text-webpack-plugin
module.exports = {"SpinnerContainer":"Spinner__SpinnerContainer__25yzX","LDSGrid":"Spinner__LDSGrid__2X_vo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 60
// module chunks = 0